import type { CommentActionType, CommentData } from '@/types';

import type { TPostCommentFormElement } from '../../postCommentFormElement';
import { ComponentContext } from './ComponentContext';
export interface ComponentContextType {
  canReply: boolean;
  showActions: boolean;
  isLive: boolean;
  isSubmitting: boolean;
  replyNode?: TPostCommentFormElement;
  onLike?: (formData: FormData) => Promise<boolean>;
  onCommentChange?: (comment: CommentData['content']) => void;
  onClickReply?: (replyingToCommentId: string | null) => void;
  onClickAction?: (action: CommentActionType, comment: CommentData) => void;
  replyingToCommentId?: string | null;
  avatarUrl?: string;
  isLoggedInAsAdmin?: boolean;
  isVisitorLoggedIn?: boolean;
  onClickLogin?: () => void;
  onClickSubscribe?: () => void;
  translations?: Record<string, string>;
  commenterId?: number | string;
}

interface ComponentProviderProps {
  children: React.ReactNode;
  canReply: boolean;
  showActions: boolean;
  isLive: boolean;
  isSubmitting: boolean;
  replyNode?: TPostCommentFormElement;
  onLike?: (formData: FormData) => Promise<boolean>;
  onCommentChange?: (comment: CommentData['content']) => void;
  onClickReply?: (replyingToCommentId: string | null) => void;
  onClickAction?: (action: CommentActionType, comment: CommentData) => void;
  replyingToCommentId?: string | null;
  avatarUrl?: string;
  isLoggedInAsAdmin?: boolean;
  isVisitorLoggedIn?: boolean;
  onClickLogin?: () => void;
  onClickSubscribe?: () => void;
  translations?: Record<string, string>;
  commenterId?: number | string;
}

export const ComponentProvider: React.FC<ComponentProviderProps> = ({
  children,
  onLike,
  onCommentChange,
  canReply,
  showActions,
  isLive,
  replyNode,
  isSubmitting,
  onClickReply,
  replyingToCommentId,
  onClickAction,
  avatarUrl,
  isLoggedInAsAdmin,
  isVisitorLoggedIn,
  onClickLogin,
  onClickSubscribe,
  translations,
  commenterId,
}) => {
  return (
    <ComponentContext.Provider
      value={{
        onLike,
        onCommentChange,
        canReply,
        showActions,
        isLive,
        replyNode,
        isSubmitting,
        onClickReply,
        replyingToCommentId,
        onClickAction,
        avatarUrl,
        isLoggedInAsAdmin,
        isVisitorLoggedIn,
        onClickLogin,
        onClickSubscribe,
        translations,
        commenterId,
      }}
    >
      {children}
    </ComponentContext.Provider>
  );
};
